import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 76" {...props}>
    <defs>
      <filter id="b" width="142.4%" height="240%" x="-21.2%" y="-50%" filterUnits="objectBoundingBox">
        <feOffset dy="8" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
      </filter>
      <filter id="d" width="144.7%" height="247.5%" x="-22.3%" y="-53.8%" filterUnits="objectBoundingBox">
        <feMorphology in="SourceAlpha" operator="dilate" radius="1.5" result="shadowSpreadOuter1" />
        <feOffset dy="8" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feMorphology in="SourceAlpha" radius="1" result="shadowInner" />
        <feOffset dy="8" in="shadowInner" result="shadowInner" />
        <feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="8" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
      </filter>
      <rect id="a" width="132" height="40" x="0" y="0" rx="20" />
      <rect id="c" width="132" height="40" x="0" y="0" rx="20" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill="#000" fillRule="nonzero" transform="translate(18 10)">
        <use xlinkHref="#a" filter="url(#b)" />
        <use xlinkHref="#a" fillOpacity=".1" />
      </g>
      <g fill="#FFF">
        <text
          fontFamily="SkyTextMedium-Regular, Sky Text"
          fontSize="16"
          fontWeight="400"
          fontStyle="normal"
          letterSpacing="1.6"
          transform="translate(33 18)"
        >
          <tspan x="30" y="19">
            RIMUOVI
          </tspan>
        </text>
        <path
          fillRule="nonzero"
          d="M34.498 24.906v13.645c0 .738.298 1.446.828 1.967.53.522 1.248.815 1.997.815H48.68c.75 0 1.468-.293 1.998-.815a2.76 2.76 0 0 0 .827-1.967V24.906a.623.623 0 0 0-.628-.618.623.623 0 0 0-.627.618v13.645c0 .41-.166.803-.46 1.093-.295.29-.694.453-1.11.453H37.324a1.58 1.58 0 0 1-1.11-.453 1.534 1.534 0 0 1-.46-1.093V24.906a.614.614 0 0 0-.184-.437.633.633 0 0 0-.444-.181.623.623 0 0 0-.628.618Zm-1.314-1.896a.633.633 0 0 0 .444.18h18.744a.623.623 0 0 0 .628-.618.623.623 0 0 0-.628-.618h-4.296v-2.408c0-.41-.166-.803-.46-1.093a1.582 1.582 0 0 0-1.11-.453h-7.012c-.416 0-.816.163-1.11.453-.294.29-.46.683-.46 1.093v2.408h-4.296a.623.623 0 0 0-.628.618c0 .164.066.321.184.437Zm5.996-3.464c0-.171.14-.31.314-.31h7.012c.084 0 .163.033.222.091a.307.307 0 0 1 .092.219v2.408h-7.64v-2.408Z"
        />
      </g>
      <g fillRule="nonzero" transform="translate(18 10)">
        <use xlinkHref="#c" fill="#000" filter="url(#d)" />
        <rect width="133.5" height="41.5" x="-.75" y="-.75" stroke="#FFF" strokeWidth="1.5" rx="20.75" />
      </g>
    </g>
  </svg>
);

const IconTrashDesktop: React.FC<IIcon> = (props: ReactProps) => <Icon {...props} svg={svg} />;

export default IconTrashDesktop;
